import { api } from '../../core/network/api';
import { startArena, type FightView } from './mobfight-api';
import type { HeroClass } from './hero-api';

/** Begin (or resume) an arena bout (the Pit) — same shared session as
 *  mob/heist fights; drive it with fightRound/fightHeal/fightAbandon. */
export const startArenaFight = startArena;
export type { FightView };

/** The concrete bot opponent held pending after a search — matchmaking
 *  synthesizes them up front so the "Opponent found" card can show WHO. */
export interface ArenaOpponent {
  name: string;
  heroClass: HeroClass;
  level: number;
  rating: number;
}

/** Search for a bout. Fast (bot-only matchmaking) — does NOT spend nerve and
 *  does NOT start the fight, it just holds the match pending server-side
 *  until accept/cancel. 400s with "Not enough nerve (need N)." if the hero
 *  can't afford a bout. */
export const searchArena = () => api.post<ArenaOpponent>('/arena/search');

/** Accept the pending match: spends the nerve and starts the SAME interactive
 *  bout `startArena`/TacticalBattle drives (400s "No opponent found — search
 *  again." if the hold expired or was never made). */
export const acceptArena = () => api.post<FightView>('/arena/accept');

/** Drop the pending match. Idempotent, never spends nerve. */
export const cancelArena = () => api.post<{ cancelled: true }>('/arena/cancel');

/** One row in the recent-bouts ledger (GET /arena/stats). */
export interface ArenaRecentBout {
  result: 'VICTORY' | 'DEFEAT';
  opponent: string;
  ratingChange: number;
  at: string;
}

/** The caller's arena standing — rating/title/W-L/streak + recent bouts. */
export interface ArenaStats {
  rating: number;
  title: string;
  wins: number;
  losses: number;
  streak: number;
  recent: ArenaRecentBout[];
}

export const fetchArenaStats = () => api.get<ArenaStats>('/arena/stats');
